import { useEffect } from "react";

export default function JoinInterview() {
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      html, body, #root {
        margin: 0;
        padding: 0;
        background-color: #005789;
        height: 100%;
        width: 100%;
      }
      .livesdk__Draggable { display: none !important; }
    `;
    document.head.appendChild(style);

    const script = document.createElement("script");
    script.src = "https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js";
    script.dataset.apikey = "ZD0cponEQvqJtgT7WVDrZA";

    const entryId = import.meta.env.VITE_ZOOM_ENTRY_ID;

    if (entryId) {
      script.dataset.entryId = entryId;
    }

    script.dataset.env = "us01";
    document.body.appendChild(script);

    let cancelled = false;

    function waitForInvitationButton(callback, timeout = 10000) {
      const start = Date.now();
      const check = () => {
        if (cancelled) return;
        const button = document.querySelector(
          '.livesdk__invitation[role="button"]'
        );
        if (button) {
          setTimeout(() => !cancelled && callback(button), 1500);
        } else if (Date.now() - start < timeout) {
          requestAnimationFrame(check);
        } else {
          location.reload();
        }
      };
      check();
    }

    function clickInvitationButton(button) {
      try {
        const event = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        });
        button.dispatchEvent(event);
      } catch {
        location.reload();
      }
    }

    const onLoad = () => waitForInvitationButton(clickInvitationButton);
    script.addEventListener("load", onLoad);
    if (script.readyState === "complete") onLoad();

    return () => {
      cancelled = true;
      script.removeEventListener("load", onLoad);
      if (script.parentNode) script.parentNode.removeChild(script);
      if (style.parentNode) style.parentNode.removeChild(style);
    };
  }, []);

  return null;
}
